<kendo-splitter orientation="horizontal" [style.height]="'100%'">
  <kendo-splitter-pane [collapsible]="true" size="33%">
    <kendo-splitter orientation="vertical" [style.height]="'100%'">
      <kendo-splitter-pane>
        <div class="pane-content" style="height:100%">
          <app-scoping-items></app-scoping-items>
        </div>
      </kendo-splitter-pane>
      <kendo-splitter-pane [collapsible]="true" size="50%">
        <div class="pane-content" style="height:calc(100% - 10px)">
          <app-dependent-items></app-dependent-items>
        </div>
      </kendo-splitter-pane>
    </kendo-splitter>
  </kendo-splitter-pane>
  <kendo-splitter-pane [scrollable]="false">
    <div class="pane-content" style="height:calc(100% - 30px)">
      <app-scoping-items-pad></app-scoping-items-pad>
    </div>
  </kendo-splitter-pane>
</kendo-splitter>